import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const TickIcon = ({ className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="20.8"
        height="20.8"
        viewBox="0 0 20.8 20.8"
        fill="none"
        stroke="currentColor"
    >
        <polyline points="19.06 1.84 8.87 17.66 1.58 10.64" strokeWidth="2.65" />
    </svg>
);

TickIcon.propTypes = propTypes;
TickIcon.defaultProps = defaultProps;

export default TickIcon;
